import styled from 'styled-components';


export const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;

    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 99;

`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    border-radius: 100px;

    background: #FFFFFF;
    
    width: 90%;
    max-width: 980px;
    margin: 1rem 1rem 0rem 1rem;
    padding: .3rem 1rem;

    font-weight: 600;
`;

export const Title = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    h2 {
        font-family: 'Inter';
        font-size: 20px;
        margin : .2rem 1rem;
    }
    img {
        margin: 0rem 1rem;
    }
`;

export const ButtonArea = styled.div`
    display: flex;

    position: relative;
    button {
        background: none;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        color: var(--text-title);
        border: 0;
        margin: 0rem 1rem;
    }
`;
